import axios from "axios";
import version from "../../version.json";
import store from "@/store";

let ACCESS_TOKEN = localStorage.getItem("access_token");
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API_SERVER + process.env.VUE_APP_ROOT_API_PATH;
axios.defaults.headers.common = {
  Authorization: `Bearer ${ACCESS_TOKEN}`,
  Accept: "application/json",
  Version: JSON.stringify(version),
};

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // A cancelled or network-level failure has no response; reading
    // .status on it threw a TypeError that masked the real error and
    // defeated axios.isCancel() downstream.
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      const result = await store.dispatch("auth/setToken");
      originalRequest.headers["Authorization"] = `Bearer ${result.access_token}`;
      originalRequest._retry = true;
      return axios(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default axios;
